import React, { useContext, useState, useEffect } from 'react';
import { auth, provider as googleProvider } from '../firebase'; // Ensure 'provider' is exported as googleProvider from firebase.js if that's its name
import {
  onAuthStateChanged,
  signInWithPopup, // We can keep this if AuthPage calls context.loginWithGoogle
  signOut
} from 'firebase/auth';

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [betaAccessVerified, setBetaAccessVerified] = useState(false);

  // List of allowed emails
  const ALLOWED_EMAILS = [
    "ethqasim@gmail.com",
    "founder@quislab.com",
    "troy@quislab.com",
    "zay218@nyu.edu",
    "mysticknight05@gmail.com",
    "talhafuzail80@gmail.com",
    "prototyp3.org@gmail.com",
    "sanyal.soumya8@gmail.com"
  ];

  // This function can be called from AuthPage.jsx if we refactor it
  function loginWithGoogle() {
    return signInWithPopup(auth, googleProvider);
  }

  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    // Check for beta access verification in localStorage
    const verified = localStorage.getItem('betaAccessVerified') === 'true';
    setBetaAccessVerified(verified);

    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user && ALLOWED_EMAILS.includes(user.email)) {
        setCurrentUser(user);
        setAuthLoading(false);
      } else if (user) {
        // User is logged in but not allowed, so log them out
        signOut(auth).then(() => {
          setCurrentUser(null);
          setAuthLoading(false);
        });
      } else {
        setCurrentUser(null);
        setAuthLoading(false);
      }
    });

    return unsubscribe; // Cleanup subscription on unmount
  }, []);

  const value = {
    currentUser,
    authLoading,
    betaAccessVerified,
    setBetaAccessVerified,
    loginWithGoogle, // Exporting this for potential use in AuthPage
    logout
  };

  // Only render children after the initial auth state has been determined.
  // This prevents rendering components that depend on currentUser before it's available.
  return (
    <AuthContext.Provider value={value}>
      {!authLoading && children}
    </AuthContext.Provider>
  );
}
